<template>
  <div v-bind:class="personClass()" >
                        
        <div v-if="!personInEdit()">
            <p class="innerTitle clubTitle">{{personNameText()}}</p>
        </div>
        <div v-if="personInEdit()">
            <p class="innerTitle clubTitle">{{personNameText()}}</p>
            
            <div class="horizFlex">
                <label for="" class="editLabel">Role</label>
                <select name="" id="" class='lookupSelect' v-model="person.roleId" >
                    <option v-for="role in rolesWithoutAll" :key="role.id" :value="role.id">
                        {{role.name}}
                    </option>
                </select>
            </div>
            
        </div>

        
        <!-- dues -->
        
        <div v-if="!personInEdit()" class="horizFlex">
            <!-- <p v-bind:class="personDuesClass()">{{personDuesText()}}</p>   -->
            <p class="unpaid" v-if="!person.isActive">INACTIVE</p> 
        </div>
        <div v-if="personInEdit()">
            <!-- <div v-bind:class="personDuesClass()">
                <input type="checkbox" id="jake" v-model="person.duesPaid">
                <label for="jake" class="rosterName" >{{editDuesPaidText}}</label>
            </div> -->
            <div class="isactivelabel">
                <input type="checkbox" id="myactive"  v-model="person.isActive" v-on:click="$emit('showinactive')" >
                <!-- v-on:click="updateIsActive(!person.isActive)" -->
                <label for="myactive" class="rosterName" >{{isActiveText}}</label>
            </div>
        </div>

        <!-- actions -->
        <div class="itemAction" v-if="!personInEdit()">
            <button class="button" v-on:click="editperson()" :disabled="disableEdit">{{editButtonText}}</button>
        </div>
        <div class="itemAction" v-if="personInEdit()">
            <button class="button" v-on:click="saveperson()">{{saveButtonText}}</button>
            <button class="button" v-on:click="$emit('canceledit')">{{cancelButtonText}}</button>
        </div>

    </div> 
</template>

<script>
import {HTTP} from '../Repository'
import tokenhelper from '../tokenhelper.js'
export default {
    name:'clubmembership',
    mixins:[tokenhelper],
    data(){
        return{
   
            editButtonText:'Edit',
            saveButtonText:'Save',
            cancelButtonText:'Cancel',
            editDuesPaidText:'Dues Paid',
            isActiveText:'Is Active',
        }
    },
    props:{
        person:{
            type:Object,
        },
        roles:{
            type:Array,
        },
        canEdit:{
            type:String,
            default:'false'
        },
    },
    computed:{
        rolesWithoutAll(){
            let tempRoles = this.roles;
            tempRoles.splice(0,1);
            
            return tempRoles;
        },
        disableEdit:function(){
            return this.canEdit=='false' || this.canEdit=='False'
        },
    },
    methods:{
        AddTokenToAPI(){
            var token = this.getToken()   
            HTTP.defaults.headers.post['token']=token
        },
        personClass(){
            if(this.person!=undefined){
                if(!this.person.isActive){
                    return "inner innerInactive itemDetail"
                }else if(this.person.tag=="Detail"){
                    return "inner itemDetailOpen";
                }else{
                    return "inner itemDetail";
                }
            }
        },
        personDuesClass(){
            if(this.person!=undefined){
                if(this.person.duesPaid){
                    return "paid";
                }else{
                    return "unpaid";
                }
            }
        },
         personDuesText(){
            if(this.person!=undefined){
                if(this.person.duesPaid){
                    return "Dues $: Paid";
                }else{
                    return "Dues $: UNPAID";
                }
            }
        },
        personNameText(){
            if(this.person!=undefined){
                this.person.roleName = this.getRoleName(this.person.roleId)
                if(this.person.roleName!=""){
                    return this.person.personName + " (" + this.person.roleName + ")";
                }else{
                    return this.person.personName;
                }
            }
        },

        toggleperson(){
            
            if(this.person!=undefined){
                if(this.person.tag==""){
                    this.person.tag="Detail"
                }else if(this.person.tag=="Detail"){
                    this.person.tag=""
                }
            }
            
        },
        personShowDetail(){
            if(this.person!=undefined){
                return this.person.tag=="Detail" || this.person.tag=="Edit"
            }
        },
        personInEdit(){
            if(this.person!=undefined){
                return this.person.tag=="Edit"
            }
        },
        editperson(){

            if(this.person!=undefined){
                this.person.tag="Edit"
            }
        },
        saveperson(){
       
            //API save
            this.savePerson
            if(this.person!=undefined){
                let req = {
                    clubmembership:this.person
                }
                this.AddTokenToAPI();
                HTTP.post('savemembership',req)
                .then(response=>{
                    
                    if(this.person!=undefined){
                        this.person.tag=""
                        this.person.clubMembershipId=response.data.ResponseInteger
                    }
                    
                })
                .catch(e=>{
                    console.log(e)
                });

                
            }
        },
      
        
        getRoleName(roleId){
            var i;
            for(i=0;i<this.roles.length;i++){
                var role = this.roles[i]
                if(role.id==roleId){return role.name}
            }
        },
    }
}
</script>

<style>
.inner{
    border-radius:10px; 
    margin:10px;
    padding:0px;
    text-align: left;
    background-color: white;
}
.innerInactive{
    background-color: lightgray;
}
.innerTitle{
    font-size:x-large;
    color:rgb(0,158,192);
}
.itemDetailOpen{
    display:grid;
    grid-template-columns:300px auto 10px 120px;
    grid-template-rows:1fr 1fr;
    grid-template-areas: 
    "clubtitle space paid action"
    "clubdate space paid action";
    height:140px;
}
.itemDetail{
    display:grid;
    grid-template-columns:300px auto 10px 120px;
    grid-template-rows:1fr;
    grid-template-areas: 
    "clubtitle space paid action";
}
.paid{
    color:green;
    font-size:large;
    margin-top:27px;
    margin-left:30px;
}
.unpaid{
    color:red;
    font-size:large;
    margin-top:27px;
    margin-left:30px;
}
.inactive{
    color:rgb(53, 48, 48);
    font-size:large;
    margin-top:27px;
    margin-left:30px;
}
.clubTitle{
    grid-area:clubtitle;
    margin-left:10px;
}
.editLabel{
    width:120px;
    margin:5px;
}
.lookupSelect{
  outline-color:rgb(238,120,45);
  outline-width:2px;
  border-radius: 5px;
  font-size:inherit;
  width:200px;
  margin-bottom:5px;
}
.itemAction{
    grid-area:action;
    display:flex;
    flex-direction: column;
    text-align: center;
}
.button{
  background-color:rgb(0,158,192);
  color:white;
   padding:10px;
   border-radius:20px;
   border:none;
   font-size:inherit;
   margin:10px 10px 0px 20px;
   width: 85px;
}
button:disabled{
    background-color:lightgray;
}
.isactivelabel{
    font-size:large;
    margin-top:10px;
    margin-left:30px;
}
</style>